import { render, staticRenderFns } from "./StartRight.vue?vue&type=template&id=35368125&"
import script from "./StartRight.vue?vue&type=script&lang=js&"
export * from "./StartRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports